// components/PatientInfoCard.jsx
import React from 'react';
import { Card, Descriptions } from 'antd';
import PropTypes from 'prop-types';

const PatientInfoCard = ({ patient }) => {
  return (
    <Card
      title={<span className="text-primary font-medium">Patient Info</span>}
      bordered={false}
      className="mb-6 bg-[#f9fafa]"
    >
      <Descriptions column={1}>

        <Descriptions.Item label="Email">
          {patient.email}
        </Descriptions.Item>
        <Descriptions.Item label="Clinic">
          {patient.clinics?.[0]?.name || 'N/A'}
        </Descriptions.Item>
      </Descriptions>
    </Card>
  );
};

PatientInfoCard.propTypes = {
  patient: PropTypes.shape({
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    clinics: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string
    }))
  }).isRequired
};

export default PatientInfoCard;